// extracted by mini-css-extract-plugin
export var documentation = "_l4-1";
export var menu = "_l4-0";